// utils/authService.ts
import store from '@/store'
import settingApi from '@/api/setting.ts'
const defaultConfig = [
  {"placeholder":'#{productName}','zh-CN':'Product','en-US':'Product'},
  {"placeholder":'#{materialName}','zh-CN':'Material','en-US':'Material'},
  {"placeholder":'#{bomName}','zh-CN':'Bom','en-US':'Bom'},
]

async function loadLanguagePackageFetch(lang: string): Promise<any> {
  try {
    // 通过 HTTP 请求获取原始 JSON
    let path = `/web/locales/${lang}.json?t=${Date.now()}`;
    const response = await fetch(path);
    if (response.ok) {
      return await response.json();
    }
    return {};
  } catch (error) {
    console.error(`Failed to fetch language package: ${lang}`, error);
    return {};
  }
}

const getSetting = async (lang:string) => {
  const currentAlias = store.getters['i18n/getAliasConfigs'];
  //console.log("4. 》》》.. getSetting 检查 currentAlias 是否存在:", currentAlias);
  if(currentAlias && currentAlias.length > 0){
    return currentAlias;
  }
  // 等待 userInfo 加载完成
  let userInfo = (store.state as any).user?.userInfo;
  let retryCount = 0
  const maxRetries = 10
  while ((!userInfo || !userInfo.customerGroupCode || !userInfo.bossNo) && retryCount < maxRetries) {
    await new Promise(resolve => setTimeout(resolve, 100))
    userInfo = (store.state as any).user?.userInfo;
    retryCount++
  }
  //console.log("4.2 . 》》》.. getSetting 等待 userInfo 加载完成:", userInfo)

  //console.log("2.1 get Setting 获取userInfo", userInfo)
  let { customerGroupCode, bossNo } = userInfo
  let param = {
    customerGroupCode, bossNo
  }

  try {
    if(document.location.pathname=='/web/register/info'){
      store.commit('i18n/SET_ALIAS_CONFIGS', defaultConfig)
      return defaultConfig;
    }
    const res = await settingApi.alias.queryUserConfig(param)
    //console.log("4.5.》》》. 接口queryUserConfig res", res)
    if (res.status == 200) {
      let aliasConfigData = res.data || []
      const resultData = aliasConfigData.map((item :any)=> {
        let { placeholder, aliasLabelCn, aliasLabelEn } = item
        let lanReplaceText = {
          'zh-CN': aliasLabelCn,
          'en-US': aliasLabelEn
        }
        return { placeholder, ...lanReplaceText }
      })
      // 放到i18n的模块中
      //console.log("5. 》》》.. 放到i18n的模块中", resultData)
      store.commit('i18n/SET_ALIAS_CONFIGS', resultData)
      return resultData
    }
    //console.log("5.5555 》》》.. 放到i18n的模块中", defaultConfig)
    store.commit('i18n/SET_ALIAS_CONFIGS', defaultConfig)
    return defaultConfig;
  } catch (err) {
    console.error("获取配置失败:", err)
    return defaultConfig;
  }
}
// 预先定义所有语言包
export async function initializeUserConfig(lang: string) {
  try {
    // 检查是否已经加载了基础消息
    const isBaseLoaded = store.getters['i18n/isBaseLoaded'];
    //console.log("1. 》》》. initializeUserConfig 检查 isBaseLoaded 状态:", isBaseLoaded);
    let baseLocalText: any = {};

    if (!isBaseLoaded) {
      await preloadBaseMessages(['zh-CN','en-US'])
    }
    baseLocalText = store.getters['i18n/baseMessages'](lang);
    //console.log("2. 》》》.. initializeUserConfig从 store 获取 baseLocalText", baseLocalText)

    if (!baseLocalText || Object.keys(baseLocalText).length == 0) {
      return;
    }

    //拿到配置项，准备替换文本
    const userConfig = await getSetting(lang);
    //console.log("6. 》》》... initializeUserConfig 获取到的 userConfig", userConfig)
    const processedUserConfig = userConfig?.map((item:any) => {
      let currentLangConfigText = item[lang];
      let { placeholder } = item;
      return {
        placeholder,
        replaceText: currentLangConfigText
      }
    })
    //console.log("6. 》》》 initializeUserConfig 解析之后的 processedUserConfig", processedUserConfig)
    // 重置动态国际化配置
    await store.dispatch('i18n/initializeDynamicI18n', {
      baseLocalText: baseLocalText,
      userConfig: processedUserConfig
    })

  } catch (error) {
    console.error('Failed to initialize user config:', error)
  }
}

// 预加载基础国际化消息
export async function preloadBaseMessages(languages: string[] = ['zh-CN', 'en-US']) {
  try {
    console.log("1. preloadBaseMessages 预加载语言包 ")
    const loadedMessages: Record<string, any> = {};
    //console.log("1.0 预加载基础国际化消息", languages)
    // 预加载所有语言的基础消息
    for (const lang of languages) {
      const messages = await loadLanguagePackageFetch(lang);
      loadedMessages[lang] = messages;
    }

    // 将默认语言的消息存储到 store
    store.dispatch('i18n/setBaseMessages', loadedMessages);
    await initializeUserConfig('en-US')
    //console.log("1.1 预加载基础国际化消息 已经完成语言vuex")
    return loadedMessages;
  } catch (error) {
    console.error('Failed to preload base messages:', error)
    return {};
  }
}